import React from "react";

import { Error } from "../../_common/Error";
import { useLogin } from "./useLogin.hooks";

export const Login = ({ goToForgotPassword }) => {
  const {
    isLoggingIn,
    username,
    password,
    error,
    activeAccountError,
    handleChange,
    handleLogin,
    resendVerificationEmail,
    successMessage
  } = useLogin();

  return (
    <>
      <form className="tw-space-y-6" onSubmit={handleLogin}>
        {error && <Error message={error} />}
        {activeAccountError && 
          <div className="alert alert-danger">
            <strong>Error!</strong> Your account has not been activated. Please check your Email for verification link to activate your account. 
            <br/><button type='button' className='btn red' onClick={resendVerificationEmail} style={{marginTop: "0.5em", marginRight: "1em"}}>Resend Activation Email</button>
          </div> 
        }
        {
          successMessage && 
          <div class="alert alert-success">
            We've sent you an email with the link to activate your account. Please check email <strong>{username}.</strong>
          </div>
        }
        <div>
          <label htmlFor="username" className="tw-m-0 tw-block tw-text-sm/6 tw-font-medium tw-text-gray-900">Email address</label>
          <div className="tw-mt-2">
            <input
              className="tw-block tw-w-full tw-rounded-md tw-bg-white tw-px-3 tw-py-1.5 tw-text-base tw-text-gray-900 tw-outline tw-outline-1 -tw-outline-offset-1 tw-outline-gray-300 placeholder:tw-text-gray-400 focus:tw-outline-2 focus:-tw-outline-offset-2 focus:tw-outline-blue-500 sm:tw-text-sm/6"
              type="email"
              autoComplete="off"
              name="username"
              required
              value={username}
              onChange={handleChange}
              data-testid="username"
            />
          </div>
         </div>
         <div>
          <div className="tw-flex tw-justify-between tw-items-center">
            <label htmlFor="password" className="tw-m-0 tw-block tw-text-sm/6 tw-font-medium tw-text-gray-900">Password</label>
            <div className="tw-text-sm">
              <button className="tw-font-semibold tw-bg-transparent tw-text-blue-500 hover:tw-text-blue-400 hover:tw-no-underline" onClick={goToForgotPassword}>Forgot Password?</button>
            </div>
          </div>
         
          <div className="tw-mt-2">
            <input
              className="tw-block tw-w-full tw-rounded-md tw-bg-white tw-px-3 tw-py-1.5 tw-text-base tw-text-gray-900 tw-outline tw-outline-1 -tw-outline-offset-1 tw-outline-gray-300 placeholder:tw-text-gray-400 focus:tw-outline-2 focus:-tw-outline-offset-2 focus:tw-outline-blue-500 sm:tw-text-sm/6"
              type="password"
              autoComplete="off"
              name="password"
              required
              aria-required="true"
              aria-invalid="false"
              value={password}
              onChange={handleChange}
              data-testid="password"
            />
          </div>
        </div>
        <div>
          <button
            className="tw-flex tw-w-full tw-rounded-md tw-bg-blue-500 tw-justify-center tw-px-3 tw-py-1.5 tw-text-sm tw-font-semibold tw-text-white tw-shadow-xs hover:tw-bg-blue-400 focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-blue-500"
            type="submit"
            disabled={isLoggingIn}
            data-testid="login-btn"
          >
            {isLoggingIn ? "Logging In..." : "Log In"}
          </button>
        </div>
      </form>
    </>
  );
};
